<h2 mat-dialog-title>Versie downloaden</h2>
<mat-dialog-content data-cy="download-sharepoint-version__dialog-content" *ngIf="initialized">
  <label>{{ data.name }}</label>
  <ul class="list-group">
    <!-- Non-image files: the whole row downloads the file -->
    <ng-container *ngIf="!isImage">
      <a data-cy="download-sharepoint-version__link" download mat-dialog-close (click)="download()">
        <li class="row list-group-item list-item d-cursor-hand" matTooltip="Laatste versie">
          <span class="col-md-2 col-xs-2">
            <mat-icon class="d-text-middle">save_alt</mat-icon>
          </span>
          <span class="col-md-10 col-xs-10 text-left">
            Laatste versie
          </span>
        </li>
      </a>
      <a data-cy="download-sharepoint-version__link-2" *ngFor="let version of versions" download mat-dialog-close (click)="download(version)">
        <li class="row list-group-item list-item d-cursor-hand" [matTooltip]="'Versie ' + version.version">
          <span class="col-md-2 col-xs-2">
            <mat-icon class="d-text-middle">save_alt</mat-icon>
          </span>
          <span class="col-md-7 col-xs-7 text-left">
            {{ version.created | formatdate: 'dd-MM-yyyy HH:mm' : globals.timezone }}
          </span>
          <span class="col-md-3 col-xs-3 text-left">
            {{ version.size | bytes }}
          </span>
        </li>
      </a>
    </ng-container>

    <!-- Image files: preview and download are separate, explicit actions -->
    <ng-container *ngIf="isImage">
      <li class="row list-group-item list-item version-row">
        <span class="col-md-2 col-xs-2 version-row-icon">
          <mat-icon class="d-text-middle">image</mat-icon>
        </span>
        <span class="col-md-6 col-xs-6 text-left version-row-label">
          Laatste versie
        </span>
        <span class="col-md-4 col-xs-4 text-right version-actions">
          <button data-cy="download-sharepoint-version__preview-btn" mat-icon-button mat-dialog-close type="button" [matTooltip]="'documents.preview' | transloco | capitaliz" (click)="lightboxOpen(data)">
            <mat-icon class="d-text-middle">visibility</mat-icon>
          </button>
          <button data-cy="download-sharepoint-version__download-btn" mat-icon-button mat-dialog-close type="button" [matTooltip]="'documents.download' | transloco | capitaliz" (click)="download()">
            <mat-icon class="d-text-middle">save_alt</mat-icon>
          </button>
        </span>
      </li>
      <li *ngFor="let version of versions" class="row list-group-item list-item version-row">
        <span class="col-md-2 col-xs-2 version-row-icon">
          <mat-icon class="d-text-middle">image</mat-icon>
        </span>
        <span class="col-md-4 col-xs-4 text-left version-row-label">
          {{ version.created | formatdate: 'dd-MM-yyyy HH:mm' : globals.timezone }}
        </span>
        <span class="col-md-2 col-xs-2 text-left version-row-label">
          {{ version.size | bytes }}
        </span>
        <span class="col-md-4 col-xs-4 text-right version-actions">
          <button data-cy="download-sharepoint-version__preview-btn-2" mat-icon-button mat-dialog-close type="button" [matTooltip]="'documents.preview' | transloco | capitaliz" (click)="lightboxOpen(version)">
            <mat-icon class="d-text-middle">visibility</mat-icon>
          </button>
          <button data-cy="download-sharepoint-version__download-btn-2" mat-icon-button mat-dialog-close type="button" [matTooltip]="'documents.download' | transloco | capitaliz" (click)="download(version)">
            <mat-icon class="d-text-middle">save_alt</mat-icon>
          </button>
        </span>
      </li>
    </ng-container>
  </ul>
</mat-dialog-content>
<div data-cy="download-sharepoint-version__page" *ngIf="!initialized" class="text-center d-text-middle row spinner-container">
  <mat-spinner [diameter]="100"></mat-spinner>
</div>
<mat-dialog-actions data-cy="download-sharepoint-version__dialog-actions">
  <button data-cy="download-sharepoint-version__close-btn" class="pull-right" mat-stroked-button mat-dialog-close (click)="close()">{{'close' | transloco | capitaliz}}</button>
</mat-dialog-actions>
